<template>
  <div class="w-full">
    <div class="member-menu">
      <h3 class="text-NotoSansRegular main-label text-center font-bold" @click="openMenu" :class="{ isTitle: isOpen }">會員中心</h3>
      <ul class="text-sm lg:text-base lg:px-2 z-50 text-NotoSansRegular textColorBlue bg-white" :class="{ open: isOpen, close: !isOpen }">
        <li class="text-NotoSansRegular border-l border-r lg:border-l-0 lg:border-r-0">
          <router-link class="block label-item" :to="{ name: 'manage' }" :class="{ textColorRed: $route.name === 'manage' }" @click.native="isOpen = false">修改會員資料</router-link>
        </li>
        <li class="text-NotoSansRegular border-l border-r lg:border-l-0 lg:border-r-0">
          <router-link class="block label-item" :to="{ name: 'order' }" :class="{ textColorRed: $route.name === 'order' }" @click.native="isOpen = false">訂單查詢</router-link>
        </li>
        <li class="text-NotoSansRegular border-l border-r lg:border-l-0 lg:border-r-0">
          <router-link class="block label-item" :to="{ name: 'commonAddress' }" :class="{ textColorRed: $route.name === 'commonAddress' }" @click.native="isOpen = false">常用收件地址</router-link>
        </li>
        <li class="text-NotoSansRegular border-l border-r lg:border-l-0 lg:border-r-0">
          <a class="block label-item cursor-pointer" @click="invoiceIndividual">會員載具歸戶</a>
        </li>
        <li class="text-NotoSansRegular border-l border-r lg:border-l-0 lg:border-r-0">
          <router-link class="block label-item" :to="{ name: 'favorite' }" :class="{ textColorRed: $route.name === 'favorite' }" @click.native="isOpen = false">收藏清單</router-link>
        </li>
      </ul>
      <form method="post" :action="$store.state.apiUrl + '/web/einvoice/auth'" target="_blank" ref="invoice">
        <input type="hidden" :name="'api_token'" :value="auth_token">
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MemberMenu',

  data () {
    return {
      isOpen: false
      // auth_token: localStorage.getItem('authToken')
    }
  },
  computed: {
    ...mapGetters([
      'authorized',
      'userRole'
    ]),
    auth_token () {
      if (localStorage.getItem('authToken')) {
        return localStorage.getItem('authToken')
      } else {
        return ''
      }
    }
  },

  methods: {
    openMenu () {
      this.isOpen = !this.isOpen
    },
    closeMenu () {
      this.isOpen = false
    },
    invoiceIndividual () {
      this.$refs.invoice.submit()
      // self.$refs.creditPay.submit()
    }
    // openMag () {
    //   let self = this
    //   let list = self.$refs.magTram
    //   if (list.classList.contains('active')) {
    //     list.classList.remove('active')
    //   } else {
    //     list.classList.add('active')
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
  .member-menu {
    h3 {
      color: white;
      background-color: #313131;
      padding: .5rem 1.5rem;
    }
    li {
      border-color: #b1b0b0;
    }
  }
  .hidenMag {
    display: none;
  }
  .label-item {
    padding: 10px 20px;
    border-bottom: 0.8px solid #b1b0b0;
    font-size: 15px;
  }
  .second-label {
    &:after {
      position: absolute;
      right: .5rem;
      top: 50%;
      transform: translateY(-50%) scaleY(.8);
      content: "▼";
      line-height: 36px;
    }
  }
  .magTram {
    width: 100%;
    ul {
      display: block;
      opacity: 0;
      height: 0px;
      overflow: hidden;
      color: #2C3E50;
      li {
        background : rgb(255, 255, 255);
        color : #434343;
        font-weight : 600;
        a {
          display: block;
          font-weight: 400;
          color: #2C3E50;
          padding: 10px 0 10px 3rem;
          transition: .2s;
          &:hover {
            cursor : pointer;
          }
        }
        &:last-child {
          border : none;
        }
      }
    }
  }
  .active {
    ul {
      opacity: 1;
      height: auto;
      width: 100%;
      border-bottom: 0.8px solid #b1b0b0;
      padding-bottom: .5rem;
      li {
        a {
          padding: 10px 0 10px 2rem;
        }
      }
    }
  }
  @media (max-width: 1023px) {
    .label-item {
      padding: 0 10px;
    }
    .member-menu {
        position: relative;
        left: 0;
        margin: 0;
        width: auto;
    }
    .member-menu {
      h3 {
        margin: 0;
        line-height: 36px;
        cursor: pointer;
        padding: 0 6px;
        border-bottom: 1px solid #dcdcdc;
        color: rgb(255, 255, 255);
        background-color: #313131;
        padding: 0;
        border: solid #dcdcdc;
        border-width: 0 0 1px;
        &:after {
          position: absolute;
          right: .6rem;
          top: 50%;
          transform: translateY(-50%) scaleY(.8);
          content: "▼";
          line-height: 36px;
        }
      }
      h3+ul {
        position: absolute;
        top: 37px;
        background-color: #ffffff;
        width: 100%;
      }
      li {
        margin-top: 0;
      }
      a {
        display: block;
        line-height: 36px;
        padding: 0 10px;
      }
    }
    .isTitle {
      &:after {
        transform: translateY(-50%) scaleY(.8) rotate(180deg) !important;
      }
    }
    .open {
      display: block !important;
    }
    .close {
      display: none;
    }
    .magTram {
      position: relative;
      width: 100%;
      box-sizing: border-box;
      vertical-align: sub;
      background-color: #ffffff;
      clear: both;
      width: 100%;
      line-height: 36px;
      &:after{
        display: none;
      }
      h3 {
        background-color: #ffffff;
      }

      a{
        text-decoration: none;
        color: black;
        padding: 17px 0px 17px 35px  !important;
        display: block;
        height: 100%;
        box-sizing: border-box;
        transition:  .3s;
      }
      .items{
        width: 100%;
        height: 0px;
        overflow: hidden;
        transition:  300ms all;
        a{
          padding: 0 .5rem  !important;
          transition:  .3s;
        }
      }
    }
    .active {
      >.items{
        display: block;
        background-color: #ffffff;
        padding: 0px;
        height: auto;
        color:rgb(0, 0, 0);
        transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
        transition: .3s;
        clear: both;
        float: left;
        width: 100%;
        li {
          padding: 0 .3rem;
          list-style: none;
        }
      }
      > a {
        padding: 0 .5rem  !important;
        text-transform: uppercase;
        font-weight: bold;
        border-bottom: 1px solid #324252;
      }
      .second-label {
        border: solid #dcdcdc;
        border-width: 0 0 1px;
      }
    }
}
</style>
